import { getOwaResourceImageUrl } from 'owa-resource-url';

export function getLoopResourceUrl() {
    return getOwaResourceImageUrl('loop.svg');
}
